import React from 'react';

import PropTypes from 'prop-types';

import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import { DiskButton } from 'apps/auth/components/common/DiskButton/DiskButton';
import { Text } from 'apps/auth/components/common/Text/Text';
import { PAYSEND_PLUS } from 'apps/auth/components/paysendPlus/utils';
import { FEE_INFO_CLICKED } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import {
    DELIVERY_CASH,
    DELIVERY_CASH_UNITELLER,
    DELIVERY_HOME,
    DELIVERY_INTERAC,
    DELIVERY_LIBRE_PAYSEND_LIVE,
    DELIVERY_PEOPLE_TRUST_INTERAC,
    PAYMENT_INTERAC,
    PAYMENT_PEOPLE_TRUST_INTERAC,
} from 'apps/auth/constants/Constants';
import { ACCOUNT, ACCOUNT_TO, FROM_ACCOUNT } from 'apps/auth/constants/fieldsName';
import { USA, VIETNAM } from 'apps/auth/constants/WellKnownCountries';
import { getTableTextColor, getTextPlusSubscriptionColor } from 'apps/auth/helpers/historyUtils';
import { getFormattedCardOrAccountNumber, toLowerCase } from 'apps/auth/helpers/utils';
import { useAuth, useExtra, useFields, usePageMessages } from 'apps/auth/hooks/selectors';
import { CheckService } from 'apps/auth/services/CheckService';

import PreCheckDeliveryRow from './PreCheckDeliveryRow';
import PreCheckRate from './PreCheckRate';
import PreCheckRecipient from './PreCheckRecipient';
import PreCheckRow from './PreCheckRow';
import UnitellerConfirmationDetails from './UnitellerConfirmationDetails';
import { TableContainer } from '../../../components/TableRow/styles';
import FeeTextPopup from '../FeeTextPopup';

const ConfirmTransactionDetails = (props) => {
    const {
        amountFromBlock,
        precheckAmountUsaFee,
        precheckPromocodeField,
        precheckAmountFee,
        precheckAmountFeeIncluded,
        amountTotalBlock,
        precheckUsaAmountFxRate,
        precheckAmountFxRate,
        improvedExchangeRateText,
        specialBonusRateInfo,
        gotIt,
        amountToBlock,
        mobilePhone,
        toBlock,
        transferPaysend,
        precheckProvider,
        toAddress,
        chequeBlockPayment,
        chequeBlockBankHeader,
        chequeBlockBankForPickupHeader,
        cashPickupHeader,
        paymentOptionText,
        chequeRecipientHeader,
        chequeRecipientInterac,
        chequeRecipientPeopleTrustInterac,
        senderEmail,
        shouldArrive,
        ...messages
    } = usePageMessages();
    const { countryId: userCountry } = useAuth();
    const { precheck, payment_form: paymentForm, sendFlowV3, toCountry, exchangeRatioText, code: codePayee, calculatorFeePopup, fromCountry } = useExtra();
    const fields = useFields(props.formName);
    const feeTextPopupForPromo = fromCountry.promoForPayment?.type ? calculatorFeePopup : null;
    const withIncluded = sendFlowV3 && !feeTextPopupForPromo;
    const shouldShowSenderEmail =
        paymentForm.toValues[FROM_ACCOUNT] && (precheck.paymentMethod === PAYMENT_INTERAC || precheck.paymentMethod === PAYMENT_PEOPLE_TRUST_INTERAC);

    if (precheck.deliveryMethod === DELIVERY_CASH_UNITELLER) {
        return (
            <UnitellerConfirmationDetails
                isLibre={props.isLibre}
                formName={props.formName}
                popupRef={props.popupRef}
                modalRef={props.modalRef}
                closeHandlerForPopup={props.closeHandlerForPopup}
                onPopupClose={props.closeHandlerForPopup}
                deliveryInformationClick={props.deliveryInformationClick}
                recipientType={props.recipientType}
                paymentMethod={precheck?.paymentMethod}
            />
        );
    } else {
        const toAccountValue = fields[ACCOUNT_TO]?.value;
        const recipient = precheck.nameTo && precheck.nameTo.trim().length > 0;
        return (
            <TableContainer indent="16px">
                {userCountry === USA && !props.isLibre && (
                    <PreCheckRow
                        title={amountTotalBlock}
                        text={
                            <>
                                {precheck.formatedAmountFrom}
                                <Text size="secondary" smallCaps>
                                    {' ' + toLowerCase(precheck.amountFromCurrency)}
                                </Text>
                            </>
                        }
                    />
                )}
                <PreCheckRow
                    onClick={() => {
                        if (precheck.commissionInfo) {
                            props.sendEvent?.(FEE_INFO_CLICKED);
                            props.popupRef?.current?.open(
                                <FeeTextPopup
                                    popupRef={props.popupRef}
                                    text={feeTextPopupForPromo || precheck.commissionInfo}
                                    isComment={true}
                                    isShowTerms={false}
                                    closeHandler={props.closeHandlerForPopup}
                                    subscriptionType={precheck.subscriptionType}
                                    onPopupClose={props.closeHandlerForPopup}
                                />,
                            );
                        }
                    }}
                    title={userCountry === USA && !props.isLibre ? precheckAmountUsaFee : withIncluded ? precheckAmountFeeIncluded : precheckAmountFee}
                    info={precheck.commissionInfo}
                    text={
                        precheck.commissionInfo ? (
                            <>
                                <Text
                                    size="secondary"
                                    color={precheck.subscriptionType === PAYSEND_PLUS ? getTextPlusSubscriptionColor(precheck) : getTableTextColor(precheck)}
                                >
                                    {(userCountry === USA && precheck.amountFrom !== precheck.amountFromWithoutFee ? ' -' : '') + precheck.commission}
                                </Text>
                                <DiskButton
                                    type="button"
                                    iconColor={
                                        precheck.subscriptionType === PAYSEND_PLUS ? getTextPlusSubscriptionColor(precheck) : getTableTextColor(precheck)
                                    }
                                    iconName="info-rounded"
                                    size="small"
                                    marginRight="-8px"
                                    marginTop="-4px"
                                    raised={false}
                                />
                            </>
                        ) : (
                            // eslint-disable-next-line react/no-unescaped-entities
                            <>
                                {' '}
                                {userCountry === USA && precheck.amountFrom !== precheck.amountFromWithoutFee ? ' -' : ''}
                                {precheck.commission}{' '}
                            </>
                        )
                    }
                />
                {precheck.promoCode && <PreCheckRow title={precheckPromocodeField} text={` ${precheck.promoCode}`} />}
                {userCountry === USA && !props.isLibre && (
                    <PreCheckRow
                        title={amountFromBlock}
                        text={
                            <>
                                {precheck.formatedAmountFromWithoutFee}
                                <Text size="secondary" smallCaps>
                                    {' ' + toLowerCase(precheck.amountFromCurrency)}
                                </Text>
                            </>
                        }
                    />
                )}
                {userCountry === USA && !props.isLibre && (
                    <PreCheckRow
                        title={amountToBlock}
                        text={
                            <>
                                {precheck.formatedAmountTo}
                                <Text size="secondary" smallCaps>
                                    {' ' + toLowerCase(precheck.amountToCurrency)}
                                </Text>
                            </>
                        }
                    />
                )}
                <PreCheckRate
                    exchangeRate={precheck.exchangeRate}
                    deliveryMethod={precheck.deliveryMethod}
                    rateInfo={precheck.rateInfo}
                    userCountry={userCountry}
                    specialBonusRateInfo={specialBonusRateInfo}
                    gotIt={gotIt}
                    exchangeRatioText={exchangeRatioText}
                    precheckUsaAmountFxRate={precheckUsaAmountFxRate}
                    precheckAmountFxRate={precheck.rateInfo?.rateChange ? improvedExchangeRateText : precheckAmountFxRate}
                    closeHandlerForPopup={props.closeHandlerForPopup}
                    popupRef={props.popupRef}
                    {...props}
                />
                {recipient && (
                    <PreCheckRecipient
                        preCheck={precheck}
                        messages={messages}
                        chequeRecipientHeader={chequeRecipientHeader}
                        paymentForm={paymentForm}
                        closeHandlerForPopup={props.closeHandlerForPopup}
                        code={codePayee}
                        {...props}
                    />
                )}
                {(precheck.deliveryMethod === DELIVERY_CASH || precheck.deliveryMethod === DELIVERY_HOME) && (precheck.toPhoneNumber || toAccountValue) && (
                    // eslint-disable-next-line
                    <PreCheckRow title={mobilePhone} text={`+${precheck.toPhoneNumber ? precheck.toPhoneNumber : toAccountValue}`} />
                )}
                {precheck.deliveryMethod === DELIVERY_LIBRE_PAYSEND_LIVE && <PreCheckRow title={mobilePhone} text={paymentForm.toValues[ACCOUNT]} />}
                {props.isLibre ? (
                    <PreCheckRow
                        title={toBlock}
                        text={
                            <>
                                {transferPaysend}
                                <DiskButton type="button" iconName="info-rounded" size="small" marginRight="-8px" marginTop="-4px" raised={false} />
                            </>
                        }
                        onClick={() => {
                            props.popupRef?.current?.open(
                                <FeeTextPopup
                                    popupRef={props.popupRef}
                                    countryToId={toCountry.id}
                                    text={messages.transferPaysendInfo}
                                    isComment={true}
                                    isShowTerms={false}
                                    deliveryMethod={precheck.deliveryMethod}
                                    closeHandler={props.closeHandlerForPopup}
                                    onPopupClose={props.closeHandlerForPopup}
                                />,
                            );
                        }}
                    />
                ) : (
                    <PreCheckRow
                        title={toBlock}
                        text={CheckService.getFormattedDeliveryAccount(
                            messages,
                            precheck.deliveryMethod,
                            userCountry,
                            toCountry.id,
                            getFormattedCardOrAccountNumber(precheck.accountTo, precheck.deliveryMethod),
                        )}
                    />
                )}

                {precheck.deliveryMethod === DELIVERY_INTERAC && <PreCheckRow title={precheckProvider} text={chequeRecipientInterac} />}
                {precheck.deliveryMethod === DELIVERY_PEOPLE_TRUST_INTERAC && <PreCheckRow title={precheckProvider} text={chequeRecipientPeopleTrustInterac} />}
                {precheck.deliveryMethod === DELIVERY_HOME && <PreCheckRow title={toAddress} text={<DangerouslyHtml dangerouslyHtml={precheck.toAddress} />} />}
                {userCountry !== USA && precheck.deliveryMethod !== DELIVERY_CASH && precheck.deliveryMethod !== DELIVERY_HOME && precheck.toBankName && (
                    <PreCheckRow title={chequeBlockBankHeader} text={`${precheck.toBankName} · ${precheck.toBankCountryName}`} />
                )}
                {precheck.deliveryMethod === DELIVERY_CASH && precheck.toBankName && (
                    <PreCheckRow
                        title={toCountry.id === VIETNAM ? chequeBlockBankForPickupHeader : cashPickupHeader}
                        text={
                            <>
                                {precheck.toPickupNetwork && (
                                    <>
                                        {precheck.toBankName}
                                        <DiskButton type="button" iconName="info-rounded" size="small" marginRight="-8px" marginTop="-4px" raised={false} />
                                    </>
                                )}
                                {!precheck.toPickupNetwork && <>{precheck.toBankName}</>}
                            </>
                        }
                        onClick={() => {
                            if (precheck.toPickupNetwork) {
                                props.popupRef?.current?.open(
                                    <FeeTextPopup
                                        popupRef={props.popupRef}
                                        text={precheck.toPickupNetwork}
                                        countryToId={toCountry.id}
                                        deliveryMethod={precheck.deliveryMethod}
                                        isComment={true}
                                        isShowTerms={true}
                                        closeHandler={props.closeHandlerForPopup}
                                        onPopupClose={props.closeHandlerForPopup}
                                    />,
                                );
                            }
                        }}
                    />
                )}

                {paymentForm.description && !props.isLibre && (
                    <PreCheckDeliveryRow
                        popupRef={props.popupRef}
                        title={shouldArrive}
                        description={paymentForm.description}
                        comment={paymentForm.comment}
                        deliveryMethod={precheck.deliveryMethod}
                        closeHandlerForPopup={props.closeHandlerForPopup}
                    />
                )}
                {precheck.accountFrom && precheck.accountFrom.length > 0 && (
                    <PreCheckRow
                        title={paymentOptionText}
                        text={CheckService.getFormattedPaymentAccount(messages, precheck.paymentMethod, userCountry, precheck.accountFrom)}
                    />
                )}
                {shouldShowSenderEmail && <PreCheckRow title={senderEmail} text={paymentForm.toValues[FROM_ACCOUNT]} />}
            </TableContainer>
        );
    }
};

ConfirmTransactionDetails.propTypes = {
    isLibre: PropTypes.bool.isRequired,
    formName: PropTypes.string.isRequired,
    closeHandlerForPopup: PropTypes.func.isRequired,
    popupRef: PropTypes.shape({ current: PropTypes.object }).isRequired,
    modalRef: PropTypes.shape({ current: PropTypes.object }),
};

export default ConfirmTransactionDetails;
